module.exports = __webpack_public_path__ + "static/img/nytj.a6366623.png";